import { FormRenderer } from './form-renderer';
import DefaultFormRenderer, { DefaultFormView, DefaultDescriptionView } from './form-renderer/default';
export { FormRenderer, DefaultFormView, DefaultDescriptionView };
export default DefaultFormRenderer;